<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headersTmp"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      :no-data-text="$t('common.common_not-register')"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td :colspan="headersTmp.length" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>

          <tr v-for="(item, trIndex) in items" :key="`group-${trIndex}`">
            <template v-for="(header, index) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none'
                }"
                :key="index"
              >
                <!-- {{ header.value }} -->
                <slot :name="header.value" v-bind:item="item">
                  <div v-if="isName(header, 'productInfo')">
                    {{ item.nameJp }} <br />
                    {{ item.nameCn }} <br />
                  </div>
                  <div v-else-if="isName(header, 'capacity')">
                    <div v-if="item.capacity">
                      {{ item.capacity }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else-if="isName(header, 'purchasePrice')">
                    <div v-if="item.purchasePrice">
                      {{
                        formatPrice(
                          Number(item.purchasePrice)
                        ).toLocaleString() +
                        getCurrencyUnitName(item.purchasePriceCurrencyId)
                      }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else-if="isName(header, 'purchasePriceCny')">
                    <div v-if="setExchangePrice(item)">
                      {{
                        formatPrice(
                          Number(setExchangePrice(item))
                        ).toLocaleString() +
                        getCurrencyUnitName(selectedCurrencyId)
                      }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else>
                    {{ getDefaultValue(item, header) }}
                  </div>
                </slot>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { commonUtil, currencyUtil } from '@/util'
import { mapGetters } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ProductTable',

  components: {},
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    headers: [],
    items: [],
    itemKey: String,
    search: { default: '' },
    productKey: String,
    selectedCurrencyId: { default: '' }
  },
  data: () => ({
    itemsDetail: [],
    productExchangePriceList: [],
    fxRate: [],
    exchangePrice: ''
  }),
  created() {
    this.createHeaders()
    this.init()
  },
  computed: {
    headersTmp() {
      const headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
      return headersTmp
    }
  },
  methods: {
    ...mapGetters('Common', ['getCurrencyListFromState']),
    async init() {
      const yesterdayDate = this.getYesterday()
      this.fxRate = await commonUtil.getFxRate(yesterdayDate)
    },
    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          align: 'align' in header ? header.align : ''
        }
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getCurrencyUnitName(currencyId) {
      const currencyInfo = this.getCurrencyListFromState().find(
        (ele) => ele.currencyId === currencyId
      )
      const currencyUnitName = currencyInfo ? currencyInfo.unitName : ''
      return currencyUnitName
    },
    // 人民元での仕入価格をfxレートから表示するために"元"のcurrencyIdを取得する処理
    setCnyCurrencyId() {
      const cnyInfo = this.getCurrencyListFromState().find(
        (ele) => ele.currencyId === this.selectedCurrencyId
      )
      const cnyCurrencyId = cnyInfo ? cnyInfo.currencyId : ''
      return cnyCurrencyId
    },
    getYesterday() {
      const now = new Date()
      const yesterday = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - 1
      )
      return (
        String(yesterday.getFullYear()) +
        '-' +
        String(yesterday.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(yesterday.getDate()).padStart(2, '0')
      )
    },
    setExchangePrice(product) {
      if (product) {
        const exchangePrice = commonUtil.exchangePriceByFxRate(
          product.purchasePriceCurrencyId,
          this.setCnyCurrencyId(),
          product.purchasePrice,
          this.fxRate
        )
        return exchangePrice ? this.formatPrice(exchangePrice) : ''
      }
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    // border: solid 1px #d8d8d8;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }

  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .DisplayNone {
    display: none;
  }
  .exportSubjectFlg {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
